import GiveFeebackPage from '../../modules/give-feedback/pages/GiveFeebackPage.vue'
import ProfilePage from '../../modules/profile/pages/ProfilePage.vue'
import DashboardPage from '../../modules/dashboard/pages/DashboardPage.vue'
import type { RouteRecordRaw } from 'vue-router'
import FeedbackHistoryPage from '../../modules/view-feedback/pages/FeedbackHistoryPage.vue'
import SurveyPage from '../../modules/survey/pages/SurveyPage.vue'
import SurveyMemberFeedbackPage from '../../modules/view-feedback/pages/SurveyMemberFeedbackPage.vue'
import SurveysPage from '../../modules/survey/pages/SurveysPage.vue'
import FeedbackRequestPage from '../../modules/open-feedbacks/pages/FeedbackRequestPage.vue'
import OnboardingPage from '../../modules/onboarding/pages/OnboardingPage.vue'
import AdminOnboarding from '../../modules/onboarding/pages/AdminOnboarding.vue'
import AcceptSpecialTermsPage from '../../modules/special-terms/pages/AcceptSpecialTermsPage.vue'
import SuperpowerPage from '../../modules/give-feedback/pages/SuperpowerPage.vue'
import PublicGiveFeebackPage from '@/modules/give-feedback/pages/PublicGiveFeebackPage.vue'
import TodosPage from '@/modules/todos/pages/TodosPage.vue'
import GiveMultipleMembersFeebackPage from '@/modules/give-feedback/pages/GiveMultipleMembersFeebackPage.vue'
import PrintProfilePage from '@/modules/profile/pages/PrintProfilePage.vue'
import SpecialTermsPage from '@/modules/special-terms/pages/SpecialTermsPage.vue'

export const coreRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'dashboard',
    component: DashboardPage,
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: OnboardingPage,
    meta: { layout: 'full-screen' },
  },
  {
    path: '/admin-onboarding',
    name: 'admin-onboarding',
    component: AdminOnboarding,
    meta: { layout: 'full-screen' },
  },
  {
    path: '/accept-special-terms',
    name: 'accept-special-terms',
    component: AcceptSpecialTermsPage,
    meta: { layout: 'full-screen' },
  },
  {
    path: '/special-terms',
    name: 'special-terms',
    component: SpecialTermsPage,
    meta: { layout: 'full-screen' },
  },
  {
    path: '/superpower',
    name: 'superpower',
    component: SuperpowerPage,
    meta: { layout: 'full-screen' },
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage,
  },
  {
    path: '/surveys',
    name: 'surveys',
    component: SurveysPage,
  },
  {
    path: '/feedbacks',
    name: 'feedbacks',
    component: FeedbackHistoryPage,
  },
  {
    path: '/feedbacks/:surveyId/member/:memberId',
    name: 'survey-member-feedback',
    component: SurveyMemberFeedbackPage,
  },
  {
    path: '/todos',
    name: 'todos',
    component: TodosPage,
  },
  {
    path: '/tasks',
    redirect: '/todos',
  },
  {
    path: '/feedback-request/:surveyId/:receiverId',
    name: 'feedback-request',
    component: FeedbackRequestPage,
    meta: {
      layout: 'full-screen',
    },
  },
  {
    path: '/surveys/:surveyId',
    name: 'survey',
    component: SurveyPage,
  },
  {
    path: '/send/:surveyId/member/:receiverId',
    name: 'feedback',
    component: GiveFeebackPage,
    meta: {
      layout: 'full-screen',
    },
  },
  {
    path: '/send/:surveyId',
    component: GiveMultipleMembersFeebackPage,
    name: 'feedback-multiple',
    meta: { layout: 'full-screen' },
  },

  {
    path: '/f/:token',
    name: 'external-feedback',
    component: PublicGiveFeebackPage,
    meta: {
      layout: 'full-screen',
      isPublic: true,
    },
  },
  {
    path: '/print-profile',
    name: 'print-profile',
    component: PrintProfilePage,
    meta: {
      layout: 'print',
      isPublic: true,
    },
  },
]
